import { EnvInterface } from "./environment.interface";

export const environment: EnvInterface = {
  production: true,
  corePath: "https://api.poshvine.com/cs/v1",
  corePathV2: "https://api.poshvine.com/cs/v1",
  offerPathV2: "https://api.poshvine.com/ps/v1",
  apiUrlBsV1: "https://api.poshvine.com/bs/v1/",
  apiUrlPaV1: "https://api.poshvine.com/pa/v1/",
  appLink: "https://smeoffers.poshvine.com",
  sentryDsn:
    "https://193b8be698fd2d0ccfde48bb202147a6@o515678.ingest.us.sentry.io/4507707416576000",
  sentryEnvironment: "production",
};
